import React from 'react'

import Navbar from '../../components/navbar/Navbar'
import Form from '../../components/form/Form'
import Main from '../../components/main/Main'
import Livecameras from '../../components/livecameras/Livecameras'
import Count from '../../components/count/Count'
import Footer from '../../components/footer/Footer'

import useForcast from '../../useForcast/useForcast'

const Home = () => {
  const { forecast, submitRequest } = useForcast()
  const submitdata = (value) => {
    submitRequest(value)
  }
  return (
    <div>
      <Navbar />

      <Form submitdatasearch={submitdata} />
      {forecast ? <Main forecast={forecast} /> : null}

      {/* <Livecameras /> */}
      <Count />
      <Footer />
    </div>
  )
}

export default Home
